// How a pot reads (finance-real round 8, slice 9 J42), on its Business expenses row and in its drawers. Not assigned is
// what the pot paid that no slice accounts for yet, a running total since its first charge: above zero it waits to be
// tagged or kept as BeNerdy's own (amber), below zero clients repaid ahead of the charges, as a year of hosting paid at
// once (blue, never red: DD-054). Every figure is the server's (TD-102).
import { Badge } from "@/components/ui/Badge";
import { ENTITY_CONFIG } from "@/core/entityConfig";
import { formatMoney } from "@/utils/currency";
import type { Pot, PotMonth } from "../types";
import { monthLabel } from "../utils/format";

const money = (minor: number) => formatMoney(minor, "EUR");
const clientsWord = ENTITY_CONFIG.client.plural.toLowerCase();

/** "October 2026: 161,17 paid · 129,86 to clients · 36,81 BeNerdy's own", the row's sub line. */
export function potMonthText(m: PotMonth): string {
  const parts = [
    m.paidMinor !== 0 ? `${money(m.paidMinor)} paid` : "nothing paid",
    m.toClientsMinor !== 0 ? `${money(m.toClientsMinor)} to ${clientsWord}` : null,
    m.ownMinor !== 0 ? `${money(m.ownMinor)} BeNerdy's own` : null,
  ].filter(Boolean);
  return `${monthLabel(m.month)}: ${parts.join(" · ")}`;
}

/** "212,40 not assigned since September 2026", or repaid ahead, or all assigned. */
export function notAssignedText(minor: number, since: string | null): string {
  if (since === null) return "No charge yet";
  const from = monthLabel(since);
  if (minor > 0) return `${money(minor)} not assigned since ${from}`;
  if (minor < 0) return `${money(-minor)} repaid ahead since ${from}`;
  return `All assigned since ${from}`;
}

export function NotAssigned({ pot }: { pot: Pot }) {
  const tone = pot.since === null ? "gray" : pot.notAssignedMinor > 0 ? "amber" : pot.notAssignedMinor < 0 ? "blue" : "green";
  return (
    <Badge tone={tone} className="whitespace-normal sm:whitespace-nowrap">
      {notAssignedText(pot.notAssignedMinor, pot.since)}
    </Badge>
  );
}
